import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  Card,
  Form,
  Input,
  Select,
  InputNumber,
  Modal,
  message,
} from "antd";
import styles from "./urllink.module.css";
import { getUrlLink } from "@api/QRcode";

const { Option } = Select;
const Urllink = (props) => {
  const gameList = props.gameList;
  const [params, setParams] = useState({
    gameId: "",
    channel: "",
    duration: 30,
  });
  const resultEle = useRef(null);
  const [showModel, setShowModel] = useState(false);
  const [result, setResult] = useState("");
  const [content, setContent] = useState("复制");
  const [disabled, setDisabled] = useState(false);

  let timer = null;

  useEffect(() => {
    return () => {
      clearTimeout(timer);
    };
  }, []);

  /**
   *
   * @param {*} e ：DomElement
   */
  const handleChange = (e) => {
    e.persist();
    setParams((prev) => ({ ...prev, channel: e.target.value }));
  };

  /**
   * @returns {valid: boolean,msg:string}
   */
  const checkParamsValid = () => {
    let valid = true;
    let msg = "";
    if (!params.gameId) {
      return { valid: false, msg: "请选择游戏" };
    }
    if (params.channel.indexOf("channel=") !== 0) {
      return { valid: false, msg: "渠道号格式须为channel=xxxx" };
    }
    if (!params.duration) {
      return { valid: false, msg: "请填写生效时间" };
    }
    return { valid, msg };
  };

  /**
   * 生成urlLink
   */
  const handleGenerateLink = async () => {
    let { valid, msg } = checkParamsValid();
    if (valid) {
      let codedData = btoa(params.channel);
      let param = {
        ...params,
        expireInterval: params.duration,
        channel: codedData,
      };
      delete param.duration;
      try {
        let res = await getUrlLink(param);
        if (res.data.meta.errCode === 0) {
          setResult(res.data.data);
          setShowModel(true);
        } else
          throw new Error(
            res.data.meta.errMsg ? res.data.meta.errMsg : "request failed"
          );
      } catch (err) {
        message.error(`生成失败，${err}`);
      }
    } else {
      message.warning(`${msg}`);
    }
  };

  const handleCopy = async () => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(result).then(
        function() {
          setDisabled(true);
          setContent("复制成功");
          message.success("复制成功");
          timer = setTimeout(() => {
            setContent("复制");
            setDisabled(false);
          }, 3000);
        },
        function() {
          console.log("err: ");
        }
      );
      return;
    } else if (document.execCommand("copy")) {
      resultEle.current.select();
      setDisabled(true);
      document.execCommand("copy", false);
      setContent("复制成功");
      message.success("复制成功");
      timer = setTimeout(() => {
        setContent("复制");
        setDisabled(false);
      }, 3000);
      return;
    }
    message.warning("该浏览器不支持自动复制，请手动复制");
    console.log("don't support auto copy ,please copy by yourself");
    return;
  };

  return (
    <Card title={"设置链接参数"} style={{ ...props.style }}>
      <Modal
        title="成功生成 URL LINK"
        visible={showModel}
        footer={[
          <Button key="back" onClick={() => setShowModel(false)}>
            关闭
          </Button>,
          <Button
            key="submit"
            type="primary"
            disabled={disabled}
            onClick={() => handleCopy()}
          >
            {content}
          </Button>,
        ]}
      >
        <div style={{ minHeight: "5rem" }}>
          <input
            className={styles.result}
            ref={resultEle}
            value={result}
            readOnly
            contentEditable={false}
            style={{ border: "none", background: "transparent" }}
          />
        </div>
      </Modal>
      <Form autoComplete="off">
        <Form.Item label="游戏" name="gameId" required>
          <Select
            showSearch
            placeholder="请选择游戏"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
            onChange={(e) => setParams((prev) => ({ ...prev, gameId: e }))}
          >
            {gameList.map((item) => {
              return (
                <Option value={item.value} key={item.value}>
                  {item.label}
                </Option>
              );
            })}
          </Select>
        </Form.Item>
        <Form.Item label="渠道号" required>
          <Input
            value={params.channel}
            onChange={handleChange}
            placeholder="填写格式：channel=xxxxxxxx"
          />
        </Form.Item>
        <Form.Item label="生效时间" required>
          <InputNumber
            max={30}
            min={1}
            style={{ width: "250px" }}
            value={params.duration}
            placeholder="请输入生效时长"
            onChange={(e) => setParams((prev) => ({ ...prev, duration: e }))}
            formatter={(value) => `${value}天`}
            defaultValue={30}
          />
        </Form.Item>
      </Form>
      <Button type="primary" onClick={() => handleGenerateLink()}>
        生成链接
      </Button>
      {result && <p className={styles.latestResult}>最近生成结果：{result}</p>}
    </Card>
  );
};

const UrlLink = React.memo(Urllink);
export default UrlLink;

